module.exports = __webpack_public_path__ + "static/media/country_st.c4b1fcf2.webp";